module.exports = __webpack_public_path__ + "static/img/pic_tupian@2x.ca2c5a27.png";